import { render, staticRenderFns } from "./CompAccordionParent.vue?vue&type=template&id=4de92e6b"
import script from "./CompAccordionParent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompAccordionParent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports